"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatTaskInventoryHierarchy = exports.buildTaskInventoriesHierarchy = void 0;
var isNil_1 = __importDefault(require("lodash/isNil"));
function populateChildren(parent, childrenByParentId) {
    if (childrenByParentId[parent.id]) {
        parent.inventories = childrenByParentId[parent.id];
        for (var i = 0; i < parent.inventories.length; ++i) {
            populateChildren(parent.inventories[i], childrenByParentId);
        }
    }
}
function buildTaskInventoriesHierarchy(taskInventories) {
    var roots = [];
    var children = {};
    // find the top level nodes and hash the children based on parent
    for (var i = 0; i < taskInventories.length; ++i) {
        var taskInventory = taskInventories[i];
        var parentId = taskInventory.parent_task_inventory_id;
        if ((0, isNil_1.default)(parentId)) {
            roots.push(taskInventory);
        }
        else {
            children[parentId] = children[parentId] || [];
            children[parentId].push(taskInventory);
        }
    }
    // enumerate through to handle the case where there are multiple roots
    for (var i = 0; i < roots.length; ++i) {
        populateChildren(roots[i], children);
    }
    return roots;
}
exports.buildTaskInventoriesHierarchy = buildTaskInventoriesHierarchy;
function flatTaskInventoryHierarchy(taskInventory, quantityFactor) {
    if (quantityFactor === void 0) { quantityFactor = 1; }
    var result = [];
    result.push(__assign({ quantityFactor: quantityFactor }, taskInventory));
    quantityFactor *= taskInventory.original_quantity;
    (taskInventory.inventories || []).forEach(function (childInventory) {
        var childInventoryWithStatus = __assign({ status: taskInventory.status }, childInventory);
        var childResult = flatTaskInventoryHierarchy(childInventoryWithStatus, quantityFactor);
        result.push.apply(result, childResult);
    });
    return result;
}
exports.flatTaskInventoryHierarchy = flatTaskInventoryHierarchy;
//# sourceMappingURL=hierarchy_actions.js.map